module.exports = __webpack_public_path__ + "static/media/girl.cbc52bc8.png";